import React from 'react';
import get from 'lodash/get';
import Description from './Description';
import classNames from 'classnames';
import ScrollToTop from './ScrollToTop';
import Helmet from 'react-helmet';

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: true,
    };

    this.stickyHome = this.stickyHome.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.stickyHome);

    console.log('hoem did mount', this.props.setNavAltColor())
    window.scrollTo(0, 0);
    this.props.setNavAltColor(false);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.stickyHome);
  }

  stickyHome() {
    const contentBottom = window.innerHeight;
    const windowScrollTop = (window.pageYOffset !== undefined) ?
      window.pageYOffset :
      (document.documentElement || document.body.parentNode || document.body).scrollTop;

    if (windowScrollTop >= contentBottom) {
      this.setState({
        isVisible: false,
      });
    } else {
      this.setState({
        isVisible: true,
      })
    }
  }

  render() {
    const title = get(this.props, 'site.title', null);
    const homeTitle = get(this.props, 'site.homeTitle', null);
    const description = get(this.props, 'site.description', null);

    if (!title || !homeTitle) {
      return null;
    }

    const siteTitle = `${title} — ${homeTitle}`;

    return (
      <div
        className="home"
        style={{
          backgroundColor: this.props.color || false,
        }}
      >
        <Helmet>
          <title>{siteTitle}</title>
        </Helmet>
        <ScrollToTop/>
        <div className={classNames('home__wrapper', {
          'is-visible': this.state.isVisible,
        })}>
        {description &&
        <Description>
          <div className="site-description" dangerouslySetInnerHTML={{ __html: description.asText() }}/>
        </Description>
        }
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js